import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom'

import { useAppContext } from '@/main/app/context'
import { useList } from '@/main/features/List/hooks/useList'

export function Form() {
  const { id } = useParams()
  const {
    formPaths: [step1],
  } = useAppContext()
  const location = useLocation()
  const list = useList(id)

  return (
    <div className="twc-prose twc-max-w-[800px] dark:twc-prose-invert prose-h2:first:twc-mt-0 prose-h2:first:twc-mb-2 twc-mb-4">
      {location.pathname.endsWith('form') || location.pathname.endsWith('form/') ? (
        <Navigate to={`/${id}/form/${step1}`} />
      ) : list ? (
        <>
          {!list.itemIds.length && (
            <div className="twc-p-4 twc-mb-12 prose-p:twc-m-0 twc-bg-amber-100 twc-rounded twc-shadow-lg twc-prose-amber dark:twc-bg-pink-400/20">
              <p>
                There are no props in your cart. <a href="/props">Browse our catalog</a> and press
                the <strong>Add to Cart</strong> button to get started.
              </p>
            </div>
          )}
          <Outlet context={{ id: list.id, form: list.form, list }} />
        </>
      ) : (
        <Navigate to="/" />
      )}
    </div>
  )
}
